<template>
  <div :style="fullscreen ? fullStyle : null">
    <div v-if="fullscreen" class="d-flex justify-end">
      <v-btn text color="primary" @click="$emit('close')">
        <v-icon left>mdi-keyboard-return</v-icon> Cerrar Vista
      </v-btn>
    </div>
    <div v-if="showFilters" class="col-12 d-flex align-center justify-center">
      <VueCtkDateTimePicker v-model="filtros.desde" label="Desde" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
        noHeader overlay :disabled="loadingData" outlined />

      <VueCtkDateTimePicker v-model="filtros.hasta" label="Hasta" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
        noHeader overlay class="mx-2" :disabled="loadingData" />


      <v-autocomplete v-model="filtros.maquinas" :items="instancias" :item-text="nombreMaquina"
        item-value="idMaquinaIns" label="Máquina (opcional)" clearable multiple chips dense class="mr-2"
        style="min-width: 400px;" :loading="loadingInstancias" />

      <v-autocomplete v-model="filtros.areas" :items="areas" item-text="nombre" item-value="idArea"
        label="Áreas (opcional)" clearable multiple chips dense style="min-width: 300px;" :loading="loadingAreas" />

      <v-btn color="primary" class="ml-2" :disabled="!validForm || loadingData" @click="searchData">
        <v-icon left>mdi-magnify</v-icon> Buscar
      </v-btn>

      <v-spacer />

      <v-btn icon @click="$emit('close')" v-if="fullscreen"><v-icon>mdi-close</v-icon></v-btn>
      <v-btn icon @click="$emit('fullscreen')" v-else><v-icon>mdi-fullscreen</v-icon></v-btn>
    </div>

    <v-row v-if="Object.keys(resultData).length > 0">
      <v-col cols="12">
        <v-row>
          <!-- Tarjetas dinámicas para datos de OEE -->
          <v-col cols="3"
            v-for="metricasConfig in reportePreferencias.metricasConfig.filter(item => item.oculto == false)"
            :key="metricasConfig.id">
            <v-card class="pa-4" elevation="1">
              <div class="d-flex align-center mb-3">
                <v-avatar :color="metricasConfig.colorFondo" size="36" class="mr-3">
                  <v-icon :color="metricasConfig.color">{{ metricasConfig.icono }}</v-icon>
                </v-avatar>
                <div>
                  <div class="font-weight-bold" :style="{ fontSize: metricasConfig.tituloTamanio + 'px !important' }">
                    {{ metricasConfig.nombre }}
                  </div>
                  <div class="text--secondary" :style="{ fontSize: metricasConfig.textoTamanio + 'px !important' }">
                    {{ getValueFromPath(resultData, metricasConfig.rellenado) }}%
                  </div>
                </div>
              </div>

              <v-progress-linear :value="getValueFromPath(resultData, metricasConfig.rellenado)" height="8"
                :color="metricasConfig.color" :background-color="metricasConfig.colorFondo" rounded />
            </v-card>
          </v-col>

          <!-- Tiempo de paro -->
          <v-col :cols="reportePreferencias.parosConfig.cols">
            <v-card ref="cardParos" class="pa-4 d-flex flex-column"
              :style="{ height: pairHeight ? (pairHeight + 'px') : 'auto' }" elevation="2">
              <div class="d-flex align-center mb-4">
                <div class="text-subtitle-1 font-weight-medium"
                  :style="{ fontSize: reportePreferencias.parosConfig.tituloTamanio + 'px !important' }">
                  Tiempo de paro
                </div>
                <v-spacer />
                <v-chip small color="blue lighten-5" text-color="blue darken-2">
                  {{ totalLabel }}
                </v-chip>
              </div>

              <v-row no-gutters align="stretch">
                <!-- Gráfica -->
                <v-col cols="12" md="6" class="pr-md-2 pb-4 pb-md-0">
                  <v-card class="pa-4" flat>
                    <div class="d-flex justify-center">
                      <apexchart type="donut" height="260" :options="chartOptions" :series="series" />
                    </div>
                    <div class="text-center caption mt-2">Programado</div>
                    <div class="d-flex align-center justify-center mt-4">
                      <div class="d-flex align-center mr-6">
                        <v-avatar size="10" color="indigo" class="mr-2" />
                        <span class="caption">Programado · {{ progLabel }}</span>
                      </div>
                      <div class="d-flex align-center">
                        <v-avatar size="10" color="orange" class="mr-2" />
                        <span class="caption">No programado · {{ noProgLabel }}</span>
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- Dos cards altura proporcional -->
                <v-col cols="12" md="6" class="pl-md-2 d-flex flex-column">
                  <!-- Programado -->
                  <v-card class="pa-4 mb-4 flex-grow-1 d-flex flex-column" outlined>
                    <div class="d-flex align-center mb-2">
                      <v-icon left color="indigo">mdi-calendar-check</v-icon>
                      <div class="subtitle-2 font-weight-medium">Paro programado</div>
                      <v-spacer />
                      <v-chip small color="blue lighten-5" text-color="blue darken-2">
                        {{ pctProg }}%
                      </v-chip>
                    </div>

                    <div class="flex-grow-1 d-flex align-center justify-center">
                      <v-row dense align="center" justify="center" class="text-center">
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ programadoParts.d }}</div>
                          <div class="caption">Días</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ programadoParts.h }}</div>
                          <div class="caption">Horas</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ programadoParts.m }}</div>
                          <div class="caption">Min</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ programadoParts.s }}</div>
                          <div class="caption">Seg</div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>

                  <!-- No programado -->
                  <v-card class="pa-4 flex-grow-1 d-flex flex-column" outlined>
                    <div class="d-flex align-center mb-2">
                      <v-icon left color="orange">mdi-alert</v-icon>
                      <div class="subtitle-2 font-weight-medium">Paro no programado</div>
                      <v-spacer />
                      <v-chip small color="orange lighten-5" text-color="orange darken-2">
                        {{ pctNoProg }}%
                      </v-chip>
                    </div>

                    <div class="flex-grow-1 d-flex align-center justify-center">
                      <v-row dense align="center" justify="center" class="text-center">
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ noProgramadoParts.d }}</div>
                          <div class="caption">Días</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ noProgramadoParts.h }}</div>
                          <div class="caption">Horas</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ noProgramadoParts.m }}</div>
                          <div class="caption">Min</div>
                        </v-col>
                        <v-col cols="3" class="d-flex flex-column align-center">
                          <div class="text-h5 font-weight-bold">{{ noProgramadoParts.s }}</div>
                          <div class="caption">Seg</div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- Calidad (Piezas Ok y no Ok) -->
          <v-col :cols="reportePreferencias.noOkConfig.cols">
            <v-card ref="cardNoOk" class="pa-4 d-flex flex-column"
              :style="{ height: pairHeight ? (pairHeight + 'px') : 'auto' }" elevation="2">
              <div class="d-flex align-center mb-4">
                <div class="text-subtitle-1 font-weight-medium">No OK</div>
                <v-spacer /><v-chip small color="red lighten-5" text-color="red darken-2">{{ totalNoOkGlobal }} no OK
                  (global)</v-chip>
              </div>

              <div class="flex-grow-1" style="overflow-y:auto">
                <v-row no-gutters>
                  <!-- Columna izquierda -->
                  <v-col cols="12" md="6" class="pr-md-3">
                    <v-list dense>
                      <v-list-item v-for="it in colLeft" :key="it.key">
                        <v-list-item-avatar color="blue lighten-5">
                          <v-icon color="blue darken-2">mdi-robot-industrial</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">{{ it.maquina }}</v-list-item-title>
                          <v-list-item-subtitle>Cavidad: {{ it.cavidad }}</v-list-item-subtitle>
                          <v-list-item-subtitle>Artículo: {{ it.articulo }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip small color="red lighten-5" text-color="red darken-2">{{ it.qty }}</v-chip>
                        </v-list-item-action>
                      </v-list-item>
                      <v-list-item v-if="!colLeft.length && !colRight.length">
                        <v-list-item-content>
                          <v-list-item-title>Sin no OK</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>

                  <!-- Columna derecha -->
                  <v-col cols="12" md="6" class="pl-md-3">
                    <v-list dense>
                      <v-list-item v-for="it in colRight" :key="it.key">
                        <v-list-item-avatar color="blue lighten-5">
                          <v-icon color="blue darken-2">mdi-robot-industrial</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">{{ it.maquina }}</v-list-item-title>
                          <v-list-item-subtitle>Cavidad: {{ it.cavidad }}</v-list-item-subtitle>
                          <v-list-item-subtitle>Artículo: {{ it.articulo }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip small color="red lighten-5" text-color="red darken-2">{{ it.qty }}</v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>

          <!-- Resultados para datos de OEE por máquina -->
          <v-col :cols="reportePreferencias.datosPorMaquinaConfig.cols">
            <v-card class="pa-4" elevation="2">
              <div class="d-flex align-center mb-4">
                <div class="text-subtitle-1 font-weight-medium">{{ modoActual }} por máquina</div>
                <v-spacer />
                <div class="px-4 pb-3 d-flex justify-center">
                  <div class="rounded-pill grey lighten-4 pa-1 d-inline-flex elevation-1">

                    <!-- OEE -->
                    <v-tooltip bottom color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                          :color="modoActual === 'OEE' ? 'primary' : 'blue lighten-5'"
                          :aria-pressed="modoActual === 'OEE'" @click="setModo('OEE')">
                          <v-icon small :color="modoActual === 'OEE' ? 'white' : 'blue darken-2'">mdi-gauge</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">OEE</span>
                    </v-tooltip>

                    <!-- Disponibilidad -->
                    <v-tooltip bottom color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                          :color="modoActual === 'Disponibilidad' ? 'primary' : 'blue lighten-5'"
                          :aria-pressed="modoActual === 'Disponibilidad'" @click="setModo('Disponibilidad')">
                          <v-icon small
                            :color="modoActual === 'Disponibilidad' ? 'white' : 'blue darken-2'">mdi-clock-check-outline</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">Disponibilidad</span>
                    </v-tooltip>

                    <!-- Eficiencia -->
                    <v-tooltip bottom color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                          :color="modoActual === 'Eficiencia' ? 'primary' : 'blue lighten-5'"
                          :aria-pressed="modoActual === 'Eficiencia'" @click="setModo('Eficiencia')">
                          <v-icon small
                            :color="modoActual === 'Eficiencia' ? 'white' : 'blue darken-2'">mdi-speedometer</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">Eficiencia</span>
                    </v-tooltip>

                    <!-- Calidad -->
                    <v-tooltip bottom color="black">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                          :color="modoActual === 'Calidad' ? 'primary' : 'blue lighten-5'"
                          :aria-pressed="modoActual === 'Calidad'" @click="setModo('Calidad')">
                          <v-icon small
                            :color="modoActual === 'Calidad' ? 'white' : 'blue darken-2'">mdi-star-check-outline</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">Calidad</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>

              <apexchart ref="maquinasChart" :key="modoActual + '-' + maquinasItems.length" type="bar"
                :height="maquinasBarHeight" :options="maquinasBarOptions" :series="maquinasBarSeries" />
            </v-card>
          </v-col>

          <!-- OEE / Piezas OK por día y máquina -->
          <v-col cols="12">
            <v-card class="pa-4" elevation="2">
              <div class="d-flex align-center mb-3">
                <div class="text-subtitle-1 font-weight-medium">{{ modoDiario }} Por Día y Máquina</div>
                <v-spacer />
                <div class="rounded-pill grey lighten-4 pa-1 d-inline-flex elevation-1">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                        :color="modoDiario === 'OEE' ? 'primary' : 'blue lighten-5'"
                        :aria-pressed="modoDiario === 'OEE'" @click="modoDiario = 'OEE'">
                        <v-icon small :color="modoDiario === 'OEE' ? 'white' : 'blue darken-2'">mdi-gauge</v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">OEE</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                        :color="modoDiario === 'TOTALES' ? 'primary' : 'blue lighten-5'"
                        :aria-pressed="modoDiario === 'TOTALES'" @click="modoDiario = 'TOTALES'">
                        <v-icon small
                          :color="modoDiario === 'TOTALES' ? 'white' : 'blue darken-2'">mdi-check-decagram-outline</v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">Piezas Totales</span>
                  </v-tooltip>
                </div>
              </div>

              <v-simple-table dense class="elevation-1">
                <thead>
                  <tr>
                    <th class="text-left">Máquina</th>
                    <th v-for="d in maquinasDiasLabels" :key="d" class="text-center">{{ d }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in maquinasHeatRows" :key="row.maquina">
                    <td class="font-weight-medium">{{ row.maquina }}</td>
                    <td v-for="(c, i) in row.cells" :key="i" class="pa-0">
                      <v-sheet :class="c.cls" class="py-2 px-0 text-center">
                        {{ c.label }}
                      </v-sheet>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="subtitle-1 font-weight-bold">
                Resumen por máquina
              </v-card-title>

              <v-data-table :headers="headers" :items="tablaMaquinas" dense fixed-header :height="420"
                class="elevation-0" :items-per-page="-1" hide-default-footer>
                <!-- Alinear números a la derecha -->
                <template v-slot:item.esperadas="{ item }">
                  <div class="text-right font-mono">{{ item.esperadas == null ? '—' : item.esperadas.toFixed(2) }}</div>
                </template>
                <template v-slot:item.hechas="{ item }">
                  <div class="text-right font-mono">{{ item.hechas == null ? '—' : item.hechas }}</div>
                </template>
                <template v-slot:item.noOk="{ item }">
                  <div class="text-right font-mono">{{ item.noOk == null ? '—' : item.noOk }}</div>
                </template>

                <!-- Fila de totales -->
                <template v-slot:body.append>
                  <tr>
                    <td class="text-right font-weight-bold">Totales</td>
                    <td class="text-right font-weight-bold font-mono">
                      {{ totales.esperadas == null ? '—' : totales.esperadas.toFixed(2) }}
                    </td>
                    <td class="text-right font-weight-bold font-mono">
                      {{ totales.hechas == null ? '—' : totales.hechas }}
                    </td>
                    <td class="text-right font-weight-bold font-mono">
                      {{ totales.noOk == null ? '—' : totales.noOk }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else class="justify-center">
      <v-col v-if="loadingData" cols="12" class="text-center">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate></v-progress-circular>
        <h2>Cargando...</h2>
      </v-col>
      <v-col cols="12" v-else-if="!loadingData && Object.keys(resultData).length == 0">
        <v-alert color="blue-grey" text class="mb-0">
          <div class="text-center" style="font-size: 16px">
            Realiza una consulta con parámetros validos
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    fullscreen: { type: Boolean, default: false },
    showFilters: { type: Boolean, default: true },
    reportePreferencias: { type: Object }
  },
  data() {
    return {
      filtros: {
        desde: null,
        hasta: null,
        maquinas: [],
        menorAMayor: true
      },
      modoActual: "OEE",
      modoDiario: 'OEE',

      instancias: [],
      areas: [],

      resultData: {},
      hastaFinal: null,

      loadingInstancias: false,
      loadingAreas: false,
      loadingData: false,


      parosHeight: 0,
      _resizeHandler: null,
      headers: [
        { text: 'Máquina', value: 'maquina' },
        { text: 'Esperadas totales', value: 'esperadas', align: 'end' },
        { text: 'Hechas totales', value: 'hechas', align: 'end' },
        { text: 'No OK totales', value: 'noOk', align: 'end' }
      ],
    }
  },
  methods: {
    getValueFromPath(obj, path) {
      if (!path) return
      return path.split('.').reduce((acc, key) => acc?.[key], obj);
    },

    num(v) { return Number(v).toLocaleString('es-MX'); },
    nombreMaquina: m => `[${m.nombre}] - ${m.marca} ${m.modelo}`,

    initialize() {
      this.getInstancias();
      this.getAreas();
    },

    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get('/MaquinaInstancias')
        .then(res => (this.instancias = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingInstancias = false;
        });
    },
    getAreas() {
      this.loadingAreas = true;
      axios
        .get('/Areas')
        .then(res => (this.areas = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingAreas = false;   // <= corregido
        });
    },

    searchData() {
      const { desde, hasta } = this.filtros;

      // Ajusta “hasta” si supera el momento actual
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const hDate = new Date(String(hasta).replace(' ', 'T'));
      const hastaFinal =
        hDate > now
          ? `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(
            now.getHours()
          )}:${pad(now.getMinutes())}`
          : hasta;
      this.hastaFinal = hastaFinal;

      this.getData(desde, hastaFinal);
    },
    getData(desde, hasta) {
      this.resultData = {};
      this.loadingData = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);

      const maquinas = this.filtros.maquinas || [];
      const idsMaquinasQS = maquinas.map(id => `idsMaquinasInstancias=${encodeURIComponent(id)}`).join('&');

      const areas = this.filtros.areas || [];
      const idsAreasQS = areas.map(id => `idsAreas=${encodeURIComponent(id)}`).join('&');

      const params = [
        `TipoOEE=${this.reportePreferencias.tipoOee ?? 1}`,
        `FechaInicio=${desdeQS}`,
        `FechaFin=${hastaQS}`,
        idsMaquinasQS,
        idsAreasQS
      ].filter(Boolean).join('&');

      axios
        .get(`/OEECalculos/OEEScoreCard?${params}`)
        .then(res => {
          this.resultData = res.data;
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingData = false;
        });
    },

    setModo(m) {
      var modes = ['OEE', 'Disponibilidad', 'Eficiencia', 'Calidad']
      if (modes.indexOf(m) === -1) m = 'OEE'
      this.modoActual = m
    },


    updateHeights() {
      var p = this.$refs.cardParos && (this.$refs.cardParos.$el || this.$refs.cardParos)
      var n = this.$refs.cardNoOk && (this.$refs.cardNoOk.$el || this.$refs.cardNoOk)
      // Usa scrollHeight para medir contenido real
      var hParos = p ? p.scrollHeight : 0
      var hNoOk = n ? n.scrollHeight : 0
      var h = Math.max(hParos, hNoOk)
      if (h && this.pairHeight !== h) this.pairHeight = h
    },
  },
  computed: {
    validForm() {
      const f = this.filtros;
      if (!f.desde || !f.hasta) return false;

      // Normaliza para evitar ambigüedad del parser
      const desde = new Date(String(f.desde).replace(' ', 'T'));
      const hasta = new Date(String(f.hasta).replace(' ', 'T'));
      return hasta > desde;
    },
    progSec() {
      var r = this.resultData && this.resultData.resumen
      return Number((r && r.tiempoParoProgramadoSegTotales) || 0)
    },
    noProgSec() {
      var r = this.resultData && this.resultData.resumen
      return Number((r && r.tiempoParoNoProgramadoSegTotales) || 0)
    },
    totalSec() { return (this.progSec || 0) + (this.noProgSec || 0) },


    // Paros
    pctProg() { return this.totalSec ? Math.round(this.progSec * 100 / this.totalSec) : 0 },
    pctNoProg() { return 100 - this.pctProg },
    programadoParts() {
      var s = Math.max(0, Math.floor(this.progSec || 0))
      var d = Math.floor(s / 86400); s %= 86400
      var h = Math.floor(s / 3600); s %= 3600
      var m = Math.floor(s / 60); s %= 60
      var hh = h < 10 ? '0' + h : '' + h
      var mm = m < 10 ? '0' + m : '' + m
      var ss = s < 10 ? '0' + s : '' + s
      return { d: d || 0, h: hh || '00', m: mm || '00', s: ss || '00' }
    },
    noProgramadoParts() {
      var s = Math.max(0, Math.floor(this.noProgSec || 0))
      var d = Math.floor(s / 86400); s %= 86400
      var h = Math.floor(s / 3600); s %= 3600
      var m = Math.floor(s / 60); s %= 60
      var hh = h < 10 ? '0' + h : '' + h
      var mm = m < 10 ? '0' + m : '' + m
      var ss = s < 10 ? '0' + s : '' + s
      return { d: d || 0, h: hh || '00', m: mm || '00', s: ss || '00' }
    },
    totalParts() {
      var s = Math.max(0, Math.floor(this.totalSec || 0))
      var d = Math.floor(s / 86400); s %= 86400
      var h = Math.floor(s / 3600); s %= 3600
      var m = Math.floor(s / 60); s %= 60
      var hh = h < 10 ? '0' + h : '' + h
      var mm = m < 10 ? '0' + m : '' + m
      var ss = s < 10 ? '0' + s : '' + s
      return { d: d || 0, h: hh || '00', m: mm || '00', s: ss || '00' }
    },

    // progLabel() { return this.programadoParts.d + 'd ' + this.programadoParts.h + 'h ' + this.programadoParts.m + 'm ' + this.programadoParts.s + 's' },
    // noProgLabel() { return this.noProgramadoParts.d + 'd ' + this.noProgramadoParts.h + 'h ' + this.noProgramadoParts.m + 'm ' + this.noProgramadoParts.s + 's' },
    totalLabel() { return this.totalParts.d + 'd ' + this.totalParts.h + 'h ' + this.totalParts.m + 'm ' + this.totalParts.s + 's totales' },
    series() { return [this.progSec, this.noProgSec] },
    chartOptions() {
      var self = this
      return {
        chart: { type: 'donut', sparkline: { enabled: true } },
        labels: ['Programado', 'No programado'],
        colors: [this.reportePreferencias.parosConfig.coloresHex.prog, this.reportePreferencias.parosConfig.coloresHex.noProg],
        legend: { show: false },
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            donut: {
              size: '78%',
              labels: {
                show: true, name: { show: false }, value: { show: false },
                total: { show: true, label: '', formatter: function () { return self.pctProg + '%' } }
              }
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              var s = Math.max(0, Math.floor(val || 0))
              var d = Math.floor(s / 86400); s %= 86400
              var h = Math.floor(s / 3600); s %= 3600
              var m = Math.floor(s / 60); s %= 60
              var hh = h < 10 ? '0' + h : '' + h
              var mm = m < 10 ? '0' + m : '' + m
              var ss = s < 10 ? '0' + s : '' + s
              return d + 'd ' + hh + 'h ' + mm + 'm ' + ss + 's'
            }
          }
        }
      }
    },



    rows() {
      var agg = {}, ms = (this.resultData && this.resultData.maquinas) || []
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i]
        var mName = m.nombre || m.maquina || m.maquinaNombre || ('Máquina ' + (i + 1))
        var pd = m.porDia || []
        for (var j = 0; j < pd.length; j++) {
          var r = pd[j]
          var qty = Number(r.piezasNoOk || 0)
          if (qty <= 0) continue // ← SOLO registros con NO OK
          var cav = r.cavidad || '—'
          var art = r.nombre || r.articuloNombre || r.codigo || r.articuloCodigo || '—'
          var key = mName + '|' + cav + '|' + art
          if (!agg[key]) agg[key] = { key: key, maquina: mName, cavidad: cav, articulo: art, qty: 0 }
          agg[key].qty += qty
        }
      }
      var out = []
      for (var k in agg) if (Object.prototype.hasOwnProperty.call(agg, k)) out.push(agg[k])
      out.sort(function (a, b) { return b.qty - a.qty })
      return out
    },
    colLeft() {
      var mid = Math.ceil(this.rows.length / 2)
      return this.rows.slice(0, mid)
    },
    colRight() {
      var mid = Math.ceil(this.rows.length / 2)
      return this.rows.slice(mid)
    },
    totalNoOkGlobal() {
      var r = this.resultData && this.resultData.resumen
      if (r && r.piezasNoOkTotales != null) return Number(r.piezasNoOkTotales)
      var sum = 0, rows = this.rows
      for (var i = 0; i < rows.length; i++) sum += Number(rows[i].qty || 0)
      return sum
    },


    // Datos por máquina
    // ---- Reemplaza maquinasItems ----
    maquinasItems() {
      // helpers locales
      function toPercent(x) {
        var v = Number(x)
        if (!isFinite(v)) return null
        // si viene en fracción 0–1, pásalo a %
        if (v <= 1.0000001 && v >= 0) v = v * 100
        // clamp
        if (v < 0) v = 0
        if (v > 100) v = 100
        return v
      }
      function toFraction(x) {
        var v = Number(x)
        if (!isFinite(v)) return null
        // si viene en %, llévalo a 0–1
        if (v > 1.0000001) v = v / 100
        if (v < 0) v = 0
        if (v > 1) v = 1
        return v
      }

      var keyMap = {
        'OEE': ['oeePromedio', 'oee', 'oeePorcentaje'],
        'Disponibilidad': ['disponibilidadPromedio', 'disponibilidad'],
        'Eficiencia': ['eficienciaPromedio', 'eficiencia'],
        'Calidad': ['calidadPromedio', 'calidad']
      }

      var out = []
      var ms = (this.resultData && this.resultData.maquinas) || []

      for (var i = 0; i < ms.length; i++) {
        var m = ms[i] || {}
        var name = m.nombre || m.maquina || m.maquinaNombre || ('Máquina ' + (i + 1))

        // 1) toma el campo según el modo
        var raw = null
        var keys = keyMap[this.modoActual] || []
        for (var k = 0; k < keys.length && raw == null; k++) {
          if (m[keys[k]] != null) raw = m[keys[k]]
        }

        // 2) normaliza a porcentaje
        var val = toPercent(raw)

        // 3) si es OEE y no hay campo, calcula D·P·Q (cuidando escalas)
        if (this.modoActual === 'OEE' && !isFinite(val)) {
          var a = toFraction(m.disponibilidadPromedio ?? m.disponibilidad)
          var p = toFraction(m.eficienciaPromedio ?? m.eficiencia)
          var q = toFraction(m.calidadPromedio ?? m.calidad)
          if (a != null && p != null && q != null) val = (a * p * q) * 100
        }

        // fallback
        if (!isFinite(val)) val = 0

        out.push({ name: name, value: val })
      }

      // ordena desc
      out.sort(function (x, y) { return y.value - x.value })
      return out
    },
    maquinasBarSeries() {
      var vals = []
      for (var i = 0; i < this.maquinasItems.length; i++) {
        vals.push(Number(this.maquinasItems[i].value || 0))
      }
      // etiqueta dinámica según modo actual
      return [{ name: this.modoActual, data: vals }]
    },
    maquinasBarCategories() {
      var cats = []
      for (var i = 0; i < this.maquinasItems.length; i++) cats.push(this.maquinasItems[i].name)
      return cats
    },
    maquinasAvg() {
      var d = (this.maquinasBarSeries[0] && this.maquinasBarSeries[0].data) ? this.maquinasBarSeries[0].data : []
      var s = 0; for (var i = 0; i < d.length; i++) s += Number(d[i] || 0)
      return d.length ? (s / d.length) : 0
    },
    maquinasAvgLabel() {
      var n = Number(this.maquinasAvg || 0)
      return isFinite(n) ? n.toFixed(2) : '0.0'
    },
    maquinasBarHeight() {
      var cfg = (this.reportePreferencias && this.reportePreferencias.datosPorMaquinaConfig) || {}
      var barPx = cfg.barPx || 42
      var minH = cfg.minHeight || 220
      var h = (this.maquinasItems.length * barPx) + 80
      return Math.max(minH, h)
    },
    maquinasLabelColors() {
      // si la cajita está activa, SIEMPRE texto blanco
      var labelCfg = (this.reportePreferencias && this.reportePreferencias.datosPorMaquinaConfig && this.reportePreferencias.datosPorMaquinaConfig.label) || {}
      if (labelCfg.box) {
        var len = (this.maquinasBarSeries[0] && this.maquinasBarSeries[0].data && this.maquinasBarSeries[0].data.length) || 1
        var arr = []; for (var i = 0; i < len; i++) arr.push('#000')
        return arr
      }

      // ← tu lógica anterior (si no hay cajita)
      var vals = (this.maquinasBarSeries[0] && this.maquinasBarSeries[0].data) || []
      var rules = (this.reportePreferencias && this.reportePreferencias.datosPorMaquinaConfig && this.reportePreferencias.datosPorMaquinaConfig.colorRules) || [
        { from: 0, to: 20, color: '#111827' },
        { from: 20.01, to: 49.99, color: '#EF4444' },
        { from: 50, to: 89.99, color: '#F59E0B' },
        { from: 90, to: 100, color: '#10B981' }
      ]
      function fillFor(v) { for (var i = 0; i < rules.length; i++) { var r = rules[i]; if (v >= r.from && v <= r.to) return r.color } return '#F59E0B' }
      function textFor(fill) { var f = (fill || '').toUpperCase(); var dark = ['#111827', '#EF4444', '#1F2937', '#0F172A']; return dark.indexOf(f) > -1 ? '#000' : '#111827' }
      var out = []; for (var j = 0; j < vals.length; j++) { out.push(textFor(fillFor(Number(vals[j] || 0)))) }
      var def = (labelCfg && labelCfg.defaultColor) || '#111827'
      return out.length ? out : [def]
    },
    maquinasBarOptions() {
      var cfg = (this.reportePreferencias && this.reportePreferencias.datosPorMaquinaConfig) || {}
      var label = cfg.label || {}
      var rules = cfg.colorRules || [
        { from: 0, to: 20, color: '#111827' },
        { from: 20.01, to: 49.99, color: '#EF4444' },
        { from: 50, to: 89.99, color: '#F59E0B' },
        { from: 90, to: 100, color: '#10B981' }
      ]
      var ranges = []; for (var i = 0; i < rules.length; i++) ranges.push({ from: rules[i].from, to: rules[i].to, color: rules[i].color })

      return {
        chart: { type: 'bar', toolbar: { show: false } },
        legend: { show: false },
        grid: { strokeDashArray: 3 },
        colors: ['#F59E0B'], // fallback
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '60%',
            dataLabels: { position: label.inside ? 'center' : 'right' },
            colors: { ranges: ranges }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: label.inside ? 'middle' : 'start',
          offsetX: label.inside ? 0 : 6,
          formatter: function (v) { v = Number(v || 0); return (isFinite(v) ? v.toFixed(2) : '0.0') + '%' },
          style: {
            fontSize: (label.fontPx || 13) + 'px',
            fontWeight: label.fontWeight || 600,
            colors: this.maquinasLabelColors
          },
          background: {
            // foreColor: '#EF4444',
            enabled: !!label.box,
            padding: 4,
            opacity: 0.9,
            borderWidth: 0
          }
        },
        xaxis: {
          categories: this.maquinasBarCategories,
          max: 100,
          labels: { formatter: function (v) { v = Number(v || 0); return (isFinite(v) ? v.toFixed(2) : '0') + '%' } }
        },
        yaxis: { labels: { minWidth: 0 } },
        tooltip: { y: { formatter: function (v) { v = Number(v || 0); return (isFinite(v) ? v.toFixed(2) : '0.00') + '%' } } }
      }
    },

    // Datos de día por día
    maquinasDiasKeys() {
      var set = {}, ms = (this.resultData && this.resultData.maquinas) || []
      for (var i = 0; i < ms.length; i++) {
        var pd = ms[i].porDia || []
        for (var j = 0; j < pd.length; j++) {
          var d = (pd[j].inicioDia || '').slice(0, 10); if (d) set[d] = 1
        }
      }
      var arr = Object.keys(set).sort() // asc
      return arr
    },
    maquinasDiasLabels() {
      var out = []
      for (var i = 0; i < this.maquinasDiasKeys.length; i++) {
        var d = this.maquinasDiasKeys[i].split('-') // YYYY-MM-DD
        out.push(d[2] + '/' + d[1] + '/' + d[0])
      }
      return out
    },

    maquinasHeatRows() {
      // — helpers —
      function toPct(v) {
        v = Number(v);
        if (!isFinite(v)) return null;
        if (v <= 1) v = v * 100;
        if (v < 0) v = 0;
        if (v > 100) v = 100;
        return v;
      }
      function cls(p) {
        if (!isFinite(p)) return 'grey lighten-3';
        if (p >= 90) return 'green darken-2 white--text';
        if (p >= 80) return 'light-green darken-1 white--text';
        if (p >= 70) return 'amber darken-2 black--text';
        if (p >= 60) return 'orange darken-1 white--text';
        if (p >= 40) return 'deep-orange darken-1 white--text';
        return 'red darken-2 white--text';
      }

      const ms = (this.resultData && this.resultData.maquinas) || [];
      const rows = [];

      for (let i = 0; i < ms.length; i++) {
        const m = ms[i] || {};
        const name = m.nombre || m.maquina || m.maquinaNombre || ('Máquina ' + (i + 1));

        // Agrupar por día
        const byDay = {};
        const pd = m.porDia || [];
        for (let j = 0; j < pd.length; j++) {
          const r = pd[j] || {};
          const key = (r.inicioDia || r.fecha || '').slice(0, 10);
          if (!key) continue;

          if (!byDay[key]) byDay[key] = { w: 0, oeeW: 0, ok: 0, tot: 0, esp: 0 };

          // Peso para OEE (usa reales si existe, si no, ok)
          const w = Number(
            r.piezasRealesTotales ?? r.reales ?? r.piezasOk ?? r.ok ?? 0
          );

          // OEE promedio (si no viene, compón con D * E * C)
          let o = Number(r.oeePromedio);
          if (!isFinite(o)) {
            o =
              (toPct(r.disponibilidadPromedio ?? r.disponibilidad) ?? 0) *
              (toPct(r.eficienciaPromedio ?? r.eficiencia) ?? 0) *
              (toPct(r.calidadPromedio ?? r.calidad) ?? 0) / 10000;
          }
          if (isFinite(o)) {
            byDay[key].oeeW += (isFinite(w) && w > 0) ? (o * w) : o;
            byDay[key].w += (isFinite(w) && w > 0) ? w : 1;
          }

          // Reales (ok + noOk si viene “reales”, si no, caída a ok)
          const reales = Number(
            r.piezasRealesTotales ?? r.reales ?? ((r.ok ?? r.piezasOk ?? 0) + (r.noOk ?? r.piezasNoOk ?? 0))
          );
          byDay[key].tot += isFinite(reales) ? reales : 0;

          // Esperadas / Teóricas (provee varios alias)
          const esperadas = Number(
            r.piezasTeoricasTotales ?? r.esperadas ?? r.piezasEsperadas ?? r.teoricas ?? r.piezasTeoricas ?? r.piezasEsperadasTotales ?? 0
          );
          byDay[key].esp += isFinite(esperadas) ? esperadas : 0;

          // Ok (por si lo usas en otro lado)
          byDay[key].ok += Number(r.piezasOk ?? r.ok ?? 0);
        }

        // Celdas por día
        const cells = [];
        const modo = this.modoDiario; // 'OEE' | 'TOTALES'
        for (let k = 0; k < this.maquinasDiasKeys.length; k++) {
          const day = this.maquinasDiasKeys[k];
          const d = byDay[day];

          if (!d) {
            cells.push({ pct: null, cls: 'grey lighten-3', label: '—' });
            continue;
          }

          if (modo === 'OEE') {
            const p = toPct(d.w ? (d.oeeW / d.w) : null);
            cells.push({ pct: p, cls: cls(p), label: isFinite(p) ? p.toFixed(2) + '%' : '—' });
            continue;
          }

          if (modo === 'TOTALES') {
            const reales = isFinite(d.tot) ? d.tot : null;
            const esp = isFinite(d.esp) && d.esp > 0 ? d.esp : null;
            const label =
              (reales != null ? reales.toLocaleString() : '—') + ' / ' +
              (esp != null ? esp.toLocaleString() : '—');
            cells.push({
              pct: null,
              cls: 'blue lighten-4 black--text',
              label
            });
            continue;
          }

          // Fallback (si existiera otro modo)
          cells.push({ pct: null, cls: 'blue lighten-4 black--text', label: (isFinite(d.tot) ? d.tot.toLocaleString() : '—') });
        }

        rows.push({ maquina: name, cells });
      }

      return rows;
    },
    tablaMaquinas() {
      const toNum = v => {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };
      const sumField = (arr, field) =>
        Array.isArray(arr)
          ? arr.reduce((acc, it) => {
            const n = toNum(it?.[field]);
            return acc + (n ?? 0);
          }, 0)
          : 0;

      const maquinas = Array.isArray(this.resultData?.maquinas)
        ? this.resultData.maquinas
        : [];

      return maquinas.map(m => {
        const maquina = m?.nombre || (m?.idMaquinaIns != null ? `ID ${m.idMaquinaIns}` : '—');

        let esperadas =
          toNum(m?.totalPiezasTeoricas) ??
          toNum(sumField(m?.porDia, 'piezasTeoricasTotales'));

        let hechas =
          toNum(m?.totalPiezasReales ?? m?.totalPiezasOk) ??
          toNum(sumField(m?.porDia, 'piezasTotales'));

        let noOk =
          toNum(m?.totalPiezasNoOk) ??
          toNum(sumField(m?.porDia, 'piezasNoOk'));

        if (esperadas != null) esperadas = Number(esperadas.toFixed(2));
        if (hechas != null) hechas = Math.round(hechas);
        if (noOk != null) noOk = Math.round(noOk);

        return { maquina, esperadas, hechas, noOk };
      });
    },

    totales() {
      const acc = this.tablaMaquinas.reduce((a, r) => {
        a.esperadas += r.esperadas ?? 0;
        a.hechas += r.hechas ?? 0;
        a.noOk += r.noOk ?? 0;
        return a;
      }, { esperadas: 0, hechas: 0, noOk: 0 });

      if (!this.tablaMaquinas.length) {
        return { esperadas: null, hechas: null, noOk: null };
      }
      return acc;
    },

    fullStyle() {
      return {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 2001,
        background: this.$vuetify?.theme?.dark ? '#121212' : '#fff',
        padding: '16px',
        overflow: 'auto'
      }
    },
  },
  mounted() {
    this.initialize();
    this.$nextTick(this.updateHeights)
    this._resizeHandler = () => this.updateHeights()
    window.addEventListener('resize', this._resizeHandler)
  },
  updated() {
    this.$nextTick(this.updateHeights)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._resizeHandler)
  },
}
</script>

<style scoped>
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>